module.exports = __webpack_public_path__ + "static/media/Illustration_Developer.daa49b2e.svg";